import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class OverlaySimulatorService {
  private latestRoute: string;

  constructor(private router: Router) {}

  rememberCurrentUrl(): void {
    this.remember(this.router.url);
  }

  remember(route: string): void {
    this.latestRoute = route;
  }

  close(): void {
    this.router.navigateByUrl(this.getCloseUrl());
  }

  getCloseUrl(): string {
    return this.latestRoute || '/support-documentation';
  }
}
